module.exports = __webpack_public_path__ + "img/29_fineStaff_wcl.3f404e3d.png";